import { useDaily } from "@daily-co/daily-react";

import { usePropagatedRouter } from "@/hooks/usePropagatedRouter";
import { VideoModes, useVideoStore } from "@/store";
import CallPanel from "./CallPanel";
import CallTray from "./CallTray";
import FloatingTile from "./FloatingTile";
import InCallConsentModal from "./InCallConsentModal";

type VideoCallContainerProps = {
  mode: VideoModes;
  leaveCall: () => void;
};

const VideoCallContainer = ({ mode, leaveCall }: VideoCallContainerProps) => {
  const callObject = useDaily();
  const { setVideoMode, videoCallConversationId } = useVideoStore();
  const router = usePropagatedRouter();

  const handleReturnToFullscreen = () => {
    setVideoMode(VideoModes.FULLSCREEN);
    if (videoCallConversationId) {
      router.navigate(`/conversation/${videoCallConversationId}`);
    }
  };

  const handleMinimizeCall = () => {
    setVideoMode(VideoModes.FLOATING);
  };

  const callContent = callObject ? (
    <>
      <CallPanel videoMode={mode} />
      {mode === VideoModes.FULLSCREEN && (
        <>
          <CallTray leaveCall={leaveCall} minimizeCall={handleMinimizeCall} />
          <InCallConsentModal />
        </>
      )}
    </>
  ) : (
    <div>Loading video call...</div>
  );

  if (mode === VideoModes.FLOATING) {
    return (
      <FloatingTile onPress={handleReturnToFullscreen}>
        {callContent}
      </FloatingTile>
    );
  }

  return callContent;
};

export default VideoCallContainer;
